// Define CSS classes
export const baseButtonStyles =
  'rounded px-3 py-1.5 text-sm font-semibold shadow-sm ring-1 ring-inset ring-gray-300';
export const buttonStyles = `${baseButtonStyles} bg-white text-gray-900 hover:bg-gray-50`;
export const blueButtonStyles = `${baseButtonStyles} bg-blue-500 text-white hover:bg-blue-600`;
export const inlineIconStyles = '-mb-1 inline -translate-y-1';
